
(ns app.strive-forms.question-fields.text-field
  (:require [app.strive-forms.component-multi-methods :refer [show-action-btn?
                                                              update-question-input-data update-question-input-local]]
            [app.strive-forms.events :as sfevents]
            [app.strive-forms.helper-functions :refer [disable-continue-button enable-continue-button
                                                       get-default-text-val process-response-all-fields! save-value-on-last-page
                                                       set-values-for-button! update-preview-panel!]]
            [app.strive-forms.styles :refer [text-field-style]]
            [clojure.string :as s]
            [re-com.core :as re-com :refer [at input-textarea]]
            [re-frame.core :as re-frame]
            [reagent.core :as r]))

(defmethod show-action-btn? "text" [_]
  true)

(defmethod update-question-input-local "text" [{:keys [input-data field-id input-value]}]
  (re-frame/dispatch [::sfevents/update-input-local
                      {:input-data input-data :key (keyword field-id) :value input-value}]))

(defmethod update-question-input-data "text" [{:keys [input-data field-id input-value]}]
  (update input-data (keyword field-id) (fn [value]
                                          (assoc value :value input-value))))


(defn text-input-field [{:keys [field]}]
  (let [is_multiple (:is_multiple (:additional_settings field) true)]
    (fn [{:keys [field field-id theme-data form-messages input-data input-value button-ids-for-button final-page?
                 default-value regenerate-display-fields current-page index]}]
      (let [text-val (r/atom (get-default-text-val {:input-data input-data :field-id field-id :default-value default-value
                                                    :current-page @current-page :index index}))
            temp-text-val (r/atom (get-default-text-val {:input-data input-data :field-id field-id :default-value default-value
                                                         :current-page @current-page :index index :num-scale-initial? false}))]
        (update-preview-panel! {:input-data input-data :field-id field-id
                                :value-to-update @text-val
                                :condition (not (s/blank? @text-val))})
        (add-watch text-val :watcher
                   #(when-not (s/blank? @text-val)
                      (set-values-for-button! {:input-value input-value :component-input-value text-val
                                               :field-id field-id :type (:type field)})))
        [:div
         {:style {:width "100%"}
          :on-blur  #(do (reset! text-val @temp-text-val)
                         (process-response-all-fields! {:input-data input-data :field-id field-id
                                                        :regenerate-display-fields regenerate-display-fields
                                                        :input-value @temp-text-val}))}
         [input-textarea :src (at)
          :model            temp-text-val
          :width "auto"
          :rows             (if is_multiple 3 1)
          :placeholder (:text_input_hint form-messages "...")
          :class (text-field-style {:color (:answers_color theme-data) :theme-data theme-data :width (if (< (.-innerWidth js/window) 800)
                                                                                                       "91.5%"
                                                                                                       "736px")})
          :on-change        #(do (reset! temp-text-val %)
                                 (if (s/blank? @temp-text-val)
                                   (disable-continue-button {:button-ids-for-button button-ids-for-button :field-id (keyword field-id)})
                                   (enable-continue-button {:button-ids-for-button button-ids-for-button :field-id (keyword field-id)}))
                                 (save-value-on-last-page {:final-page? final-page? :input-data input-data :field-id field-id
                                                           :regenerate-display-fields regenerate-display-fields :text-val temp-text-val}))
          :change-on-blur?  false]]))))
